<div class="main-wrap" id="loading"
     [style]="backGroundStyle"
     *ngIf="gameInit">
    <div class="play-button" *ngIf="showPlayButton" (click)="hideLoading()">
        <img src="../../../assets/common/sprites/play-button.png" alt="">
    </div>
</div>
